module.exports = __webpack_public_path__ + "gw.svg?1ea244637aa5bc1fb63541b77e6a54c0";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/gw.svg
// module id = 1140
// module chunks = 0